import { defineRecipe } from '@chakra-ui/react';

/**
 * Digitane AI Textarea Recipe
 * Custom textarea variants for chat input
 */

export const textareaRecipe = defineRecipe({
  className: 'textarea',
  base: {
    width: '100%',
    outline: 'none',
    transition: 'all 0.2s',
    resize: 'none',
    _disabled: {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  variants: {
    variant: {
      // Minimal/Unstyled variant for chat input
      unstyled: {
        bg: 'transparent',
        border: 'none',
        px: 0,
        py: 0,
        _focus: {
          outline: 'none',
          boxShadow: 'none',
        },
      },
      // Outline variant for forms
      outline: {
        border: '1px solid',
        borderColor: 'borders.default',
        borderRadius: 'md',
        px: 3,
        py: 2,
        bg: 'white',
        _focus: {
          borderColor: 'primary',
          boxShadow: 'focusRing',
        },
        _invalid: {
          borderColor: 'semantics.error',
        },
      },
    },
    size: {
      sm: {
        fontSize: 'sm',
        minH: 20,
      },
      md: {
        fontSize: 'md',
        minH: 24,
      },
      lg: {
        fontSize: 'lg',
        minH: 32,
      },
    },
  },
  defaultVariants: {
    variant: 'outline',
    size: 'md',
  },
});
